module.exports = __webpack_public_path__ + "img/back-2-ba6ec097.png";